import React, { useEffect, useState } from 'react';
import { Spin, Checkbox, Input, Button, message, Tag, Pagination,Popconfirm } from 'antd';
import App from '../LayoutMobile';
import { useLocation } from 'react-router-dom';
import { Config } from '../Common/Config';
import moment from 'moment';

function PendingRefunds() {
  const location = useLocation();
  const { clinic_id, date, end_date } = location.state || {};
  const [loading, setLoading] = useState(true);
  const [refunds, setRefunds] = useState([]);
  const [paginationData, setpaginationData] = useState({});
  const [customAmounts, setCustomAmounts] = useState({});
  const [customChecked, setCustomChecked] = useState({});
  const [CurrentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();
  // console.log('PendingRefunds clinic_id:', Config.url);
  useEffect(() => {

    fetchRefunds(CurrentPage);
  }, [clinic_id, date, end_date, CurrentPage]);
  const fetchRefunds = async (CurrentPage = 1) => {
    setLoading(true);
    try {
      const rawDate = location.state?.date;
      const rawEndDate = location.state?.end_date;

      // Using moment.js for formatting
      const formattedDate = rawDate ? moment(rawDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
      const formattedEndDate = rawEndDate ? moment(rawEndDate).format('YYYY-MM-DD') : formattedDate;
      const params = new URLSearchParams({
        clinic_id,
        date: formattedDate,
        end_date: formattedEndDate
      }).toString();
      const response = await fetch(`${Config.url}conflict-alerts?page=${CurrentPage}&type=refund`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      const data = await response.json();
      // console.log('PendingRefunds data:', data.pending_refunds_alert);
      setRefunds(data.pending_refunds_alert || []);
    } catch (error) {
      setRefunds([]);
    }
    setLoading(false);
  };

  // Handlers for custom refund amount
  const handleCustomCheck = (id, checked) => {
    setCustomChecked(prev => ({ ...prev, [id]: checked }));
    if (!checked) setCustomAmounts(prev => ({ ...prev, [id]: '' }));
  };
  const handleCustomAmountChange = (id, value) => {
    setCustomAmounts(prev => ({ ...prev, [id]: value }));
  };
  const handleRefund = async (item) => {
    // console.log("handleRefund::", item)
    let refund_amount = item.refund_amount;
    if (customChecked[item.appointment_id] && customAmounts[item.appointment_id]) {
      refund_amount = parseFloat(customAmounts[item.appointment_id]);
    }

    try {
      const response = await fetch(`${Config.url}stripe-refund`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          payment_intent_id: item.payment_intent_id,
          amount: refund_amount,
          reason: 'requested_by_customer',
          appointment_id: item.appointment_id.toString()
        })
      });

      const data = await response.json();
      // console.log("data", data)
      if (data && data.status === 'success') {
        // Optionally show success message or update UI
        messageApi.success('Refund processed successfully!');
        // setRefunds(prev => prev?.data?.filter(ref => ref?.appointment_id !== item.appointment_id));
        setRefunds(prev => ({
          ...prev,
          data: prev?.data?.filter(ref => ref?.appointment_id !== item.appointment_id)
        }));
      } else {
        // Optionally show error message
        messageApi.error(data.message || 'Refund failed');
      }
    } catch (error) {
      messageApi.error('Refund failed');
    }
  };
  const handlePageChange = (data) => {
    // console.log('handlePageChange::::', data)
    setCurrentPage(data)
  }
  return (
    <App>
      {contextHolder}
      <h2 style={{ textAlign: 'left', margin: '20px 0 24px 0' }}>Pending refunds</h2>
      {loading ? (
        <div style={{ textAlign: 'center', marginTop: 40 }}>
          <Spin className="custom-spinner" size="large" />
        </div>
      ) : (
        <>
          <div style={{ display: 'flex', gap: 32, flexWrap: 'wrap', lineHeight: 1.8 }}>
            {refunds && refunds.data && refunds.data.map((item, idx) => (
              <div
                key={item.appointment_id || idx}
                style={{
                  background: '#eaf8f8',
                  borderRadius: 16,
                  boxShadow: '0 2px 6px #0001',
                  padding: 24,
                  minWidth: 300,
                  maxWidth: 340,
                  flex: '1 1 320px',
                  marginBottom: 24,
                  position: 'relative',
                  textAlign: 'left' // <-- add this line
                }}
              >
                <div style={{
                  background: '#009999',
                  color: '#fff',
                  borderRadius: '12px 12px 0 0',
                  padding: '10px 0',
                  textAlign: 'center',
                  fontWeight: 600,
                  fontSize: 18,
                  margin: '-24px -24px 16px -24px'
                }}>
                  Appointment details:
                  <span
                    style={{
                      position: 'absolute',
                      right: 18,
                      top: 10,
                      cursor: 'pointer',
                      color: '#fff',
                      fontWeight: 400,
                      fontSize: 18
                    }}
                    onClick={() => { /* Optionally handle close */ }}
                  >×</span>
                </div>
                <div style={{ fontSize: 15, marginBottom: 8, textAlign: 'left' }}> {/* <-- add textAlign here too */}
                  <div><b>{item.clinic_name}</b></div>
                  <div>
                    {new Date(item.start_time).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                  </div>
                  <div>{item.start_time?.slice(11, 16)} - {item.end_time?.slice(11, 16)}</div>
                  <div>{item.product_category_name}: £{item.charges}</div>
                  {/* {item.discount_amount > 0 ? <div>Discount: £{item.discount_amount}</div> : ''} */}
                  {item.additional_charges > 0 ? <div>{"Additional Payment"}: £{Number(item.additional_charges || 0).toFixed(2)}</div> : ''}
                  {item.discount_amount > 0 ? <div>Total amount paid so far: £{Number(parseFloat(item.charges) - parseFloat(item.discount_amount)).toFixed(2)}</div> : ''}
                  {item.preferred_gender ? <div>{item.preferred_gender}, {item.language_name}</div> : ''}
                  <div>{item.patient?.first_name} {item.patient?.last_name}</div>
                  <div>{item.patient?.email} &nbsp; {item.patient?.mobile_number}</div>
                  {(() => {
                    const isRescheduledAppointment =
                      item?.is_rescheduled === true ||
                      item?.is_rescheduled === 'true' ||
                      item?.is_rescheduled === 1 ||
                      item?.is_rescheduled === '1';
                    return isRescheduledAppointment ? (
                      <>
                        <div><b>Original appointment</b></div>
                        {/* <div>Original amount: £{item.original_amount || 0}</div> */}
                        <div>{item.product_category_name}: £{Number(item.original_amount || 0).toFixed(2)}</div>
                        <div>Discount: £{Number(item.discount_applied || 0).toFixed(2) }</div>
                        <div>Amount paid: £{Number(item.final_amount || 0).toFixed(2)}</div>
                      </>
                    ) : null;
                  })()}
                  <div>Notes: {item.notes}</div>
                  <div>Additional notes: {item.additional_notes}</div>
                  {/* <div>
                  Cancellation charges waived: <b>{parseFloat(item.cancellation_charge) === 0 ? 'Yes' : 'No'}</b>
                </div>
                <div style={{ margin: '8px 0' }}>
                  Refund amount: <b>£ {item.refund_amount}</b>
                </div> */}
                  <div style={{ display: 'flex', gap: 12, alignItems: 'center', margin: '8px 0' }}>
                    <span>Cancellation charges waived:</span>
                    <Tag
                      style={{
                        minWidth: 48,
                        textAlign: 'center',
                        fontWeight: 700,
                        height: 32, // Match Input height
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 12px',
                        fontSize: 16,
                        boxSizing: 'border-box'
                      }}>
                      {parseFloat(item.cancellation_charge) === 0 ? 'Yes' : 'No'}
                    </Tag>
                  </div>
                  <div style={{ display: 'flex', gap: 12, alignItems: 'center', margin: '8px 0' }}>
                    <span>Refund amount:</span>
                    <Tag
                      color="default"
                      style={{
                        minWidth: 60,
                        textAlign: 'center',
                        fontWeight: 700,
                        height: 32, // Match Input height
                        display: 'flex',
                        alignItems: 'center',
                        padding: '0 12px',
                        fontSize: 16,
                        boxSizing: 'border-box'
                      }}>
                      £ {Number(item.refund_amount || 0).toFixed(2)}
                    </Tag>
                  </div>
                  <div>
                    <Checkbox
                      checked={!!customChecked[item.appointment_id]}
                      onChange={e => handleCustomCheck(item.appointment_id, e.target.checked)}
                    >
                      Custom refund amount:
                    </Checkbox>
                    <Input
                      style={{ width: 100, marginLeft: 8 }}
                      disabled={!customChecked[item.appointment_id]}
                      value={customAmounts[item.appointment_id] || ''}
                      onChange={e => {
                        const val = e.target.value;
                        if (/^(?:\d*\.?\d*)?$/.test(val)) {
                          handleCustomAmountChange(item.appointment_id, val);
                        }
                      }}
                      prefix="£"
                    />
                  </div>
                  {/* <Button
                    type="primary"
                    style={{ marginTop: 16, width: '100%' }}
                    onClick={() => handleRefund(item)}
                  >
                    Refund
                  </Button> */}
                  <Button
                    type="primary"
                    style={{ marginTop: 16, width: '100%' }}
                  >
                    <Popconfirm
                      title="Are you sure you want to proceed with this refund?"
                      onConfirm={() => handleRefund(item)}
                      okText="Yes"
                      cancelText="No"
                    >
                      Refund
                    </Popconfirm>
                  </Button>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
            <Pagination defaultCurrent={CurrentPage} pageSize={10} total={refunds.meta.total} onChange={handlePageChange} showSizeChanger={false} />
          </div>
        </>
      )}
    </App>
  );
}

export default PendingRefunds;